<h3 mat-dialog-title>Recuperação de senha</h3>
  <form [formGroup]="form">
    <div fxLayout="column">
      <mat-form-field fxFlex="auto">
        <input matInput autocomplete="email" formControlName="email" placeholder="Email" aria-label="Email" required >
        <mat-error *ngIf="form.controls['email'].invalid">Informe o Email do usuário</mat-error>
      </mat-form-field>
      <button mat-raised-button [disabled]="form.invalid" (click)="enviarRecuperacao()" style="margin-top: 5px;" color="primary"><mat-icon>input</mat-icon> Recuperar senha</button>
    </div>
  </form>